import { EuiButton, EuiButtonEmpty, EuiLink, SortDirection } from '@elastic/eui'
import { EuiBasicTableColumn } from '@elastic/eui/src/components/basic_table/basic_table'

import { Account } from 'api/interfaces'
import { useGetAccountsQuery } from 'api/rtkQueryApi/platform/accountsApi'
import { useWhiteLabel } from 'whiteLabel/WhiteLabelContext'

import { AcEuiInMemoryTableWithSearch } from '../../components/Basic/AcEuiInMemoryTableWithSearch'
import { formatPhoneNumber } from '../../utils/Formatters'

interface ClientsGridProps {
  clientAction?: (account: Account) => void
  onClickClientName?: (account: Account) => void
  onCreateClient?: () => void
}

export const ClientsGrid = ({ clientAction, onClickClientName, onCreateClient }: ClientsGridProps) => {
  const whiteLabel = useWhiteLabel()
  const { isLoading, data: accounts } = useGetAccountsQuery(
    { isAgency: whiteLabel?.isAgencies() },
    {
      skip: !whiteLabel
    }
  )
  const columns: Array<EuiBasicTableColumn<Account>> = [
    {
      name: 'Client Name',
      render: (account: Account) =>
        onClickClientName ? (
          <EuiButtonEmpty
            color={'success'}
            onClick={() => {
              onClickClientName(account)
            }}>
            {account.name}
          </EuiButtonEmpty>
        ) : (
          account.name
        ),
      sortable: true
    },
    {
      name: 'Contact Name',
      render: (account: Account) => `${account.contactFirstName ?? ''} ${account.contactLastName ?? ''}`,
      sortable: (account: Account) => `${account.contactFirstName} ${account.contactLastName}`
    },
    {
      name: 'Contact Email',
      field: 'contactEmail',
      sortable: true
    },
    {
      name: 'Contact Phone Number',
      field: 'contactPhone',
      sortable: true,
      render: (phone: string) => formatPhoneNumber(phone)
    },
    {
      name: 'Website',
      render: (account: Account) => {
        return (
          account.website && (
            <EuiLink href={account.website} target={'_blank'}>
              {account.website}
            </EuiLink>
          )
        )
      }
    }
  ] as EuiBasicTableColumn<Account>[]

  if (clientAction) {
    columns.push({
      name: 'Select',
      render: (account: Account) => <EuiButton onClick={() => clientAction(account)}>Select</EuiButton>
    })
  }

  const sorting = {
    sort: {
      field: 'name',
      direction: SortDirection.ASC
    }
  }

  return (
    <AcEuiInMemoryTableWithSearch
      searchFields={['name']}
      message={isLoading ? 'Loading clients...' : 'No clients found'}
      search={{
        toolsRight: onCreateClient
          ? [
              <EuiButton fill size={'s'} onClick={onCreateClient}>
                Create Client
              </EuiButton>
            ]
          : []
      }}
      loading={isLoading}
      items={accounts ?? []}
      columns={columns}
      sorting={sorting}
    />
  )
}
